import { DialogTitle, Typography } from '@mui/material';
import { X } from '../../../../../icons/x';
import { DialogStyle } from './style';

type ModalTitleProps = {
   onCloseModal: () => void,
   title: string,
}

const ModalTitle = ({
  onCloseModal,
  title,
}: ModalTitleProps):JSX.Element => {
  return (
    <DialogTitle
      style={ DialogStyle.dialogTitle.style }
      sx={ DialogStyle.dialogTitle.sx }
    >
      <Typography>{title}</Typography>
      <X
        onClick={ onCloseModal }
        style={ DialogStyle.close }
      />
    </DialogTitle>
  );
};

export default ModalTitle;
